// extracted by mini-css-extract-plugin
export default {"title":"SupportList_title__UtQXT","category_name":"SupportList_category_name__33a2e","center_align":"SupportList_center_align__nOg4x","no_result":"SupportList_no_result__AUzqv"};